import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-strip-list-header',
  templateUrl: './strip-list-header.component.html',
  styleUrls: ['./strip-list-header.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: []
})
export class StripListHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
